import './App.css';
import InvoiceGenerator from './components/InvoiceGenerator';


function App() {
    return (
        <div>
          <InvoiceGenerator/>
        </div>
    );
}

export default App;
